<script setup>
const props = defineProps({
    image: {
        type: Object,
        required: true
    }
});

const height = computed(() => props.image?.height);
const width = computed(() => props.image?.width);
const src = computed(() => props.image?.url);
const isSvg = computed(() => {
    const extension = props.image?.extension?.toLowerCase();
    const mimeType = props.image?.mimeType?.toLowerCase();
    const url = props.image?.url ?? '';

    return extension === 'svg'
        || mimeType === 'image/svg+xml'
        || /\.svg(?:[?#]|$)/i.test(url);
});
const avifSrc = computed(() => isSvg.value ? null : props.image?.avif);
const webpSrc = computed(() => isSvg.value ? null : props.image?.webp);

const srcses = computed(() =>
    isSvg.value ? [] : Object.entries(props.image)
        .map(([key, value]) => {
            const matches = key.match(/^w([\d]+)$/);
            if (value && matches?.[1]) {
                return `${value} ${matches[1]}w`;
            }
            return false;
        })
        .filter(v => v)
);

const webpSrcses = computed(() =>
    isSvg.value ? [] : Object.entries(props.image)
        .map(([key, value]) => {
            const matches = key.match(/^w([\d]+)_webp$/);
            if (value && matches?.[1]) {
                return `${value} ${matches[1]}w`;
            }
            return false;
        })
        .filter(v => v)
);

const avifSrcses = computed(() =>
    isSvg.value ? [] : Object.entries(props.image)
        .map(([key, value]) => {
            const matches = key.match(/^w([\d]+)_avif$/);
            if (value && matches?.[1]) {
                return `${value} ${matches[1]}w`;
            }
            return false;
        })
        .filter(v => v)
);

const srcset = computed(() => srcses.value?.join(', '));
const webpSrcset = computed(() => webpSrcses.value?.join(', '));
const avifSrcset = computed(() => avifSrcses.value?.join(', '));
</script>

<template>
    <slot
        name="default"
        :height="height"
        :width="width"
        :src="src"
        :avif-src="avifSrc"
        :webp-src="webpSrc"
        :srcset="srcset"
        :avif-srcset="avifSrcset"
        :webp-srcset="webpSrcset"
    />
</template>
